import { render, staticRenderFns } from "./50.vue?vue&type=template&id=5387a390&scoped=true&"
import script from "./50.vue?vue&type=script&lang=js&"
export * from "./50.vue?vue&type=script&lang=js&"
import style0 from "./50.vue?vue&type=style&index=0&id=5387a390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387a390",
  null
  
)

export default component.exports